import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import Business from '@/models/Business.js'

export const useBusinessStore = defineStore('businessStore', () => {
  let syncableModel = useSyncableModel(useApiResource('businesses'), {
    className: Business.modelName.name,
    paramKey: Business.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }
  
  return {
    ...syncableModel,
    $reset
  }  
}, {
  persist: true
})
